// @flow
export const VERSION = '1.0';
export const MIME_TYPE = 'application/vnd.api+json';
